import React from 'react';

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'core-js/stable';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { StylesProvider } from '@material-ui/styles';

import App from './main/App';
import jss from './main/jss';

import store from './store/createStore';

import * as serviceWorker from './serviceWorker';

const application = (
  <Provider store={store}>
    <StylesProvider jss={jss}>
      <App />
    </StylesProvider>
  </Provider>
);
ReactDOM.render(application, document.getElementById('root'));

serviceWorker.unregister();
